import { useState } from "react"
import { QueryClient, useMutation } from "@tanstack/react-query"
import { refreshStatistics } from "./apiCalls"
import { messageError, messagePending, messageSuccess } from "../../../services/messages"
import { apiErrorMessage } from "../../../services/apiErrorText"



// Function to refresh the statistics manually
export const useRefreshStatisticsMutation = (queryClient: QueryClient, queryKey: string) => {
    const [notificationKey, setnotificationKey] = useState<string>("")
    const mutation = useMutation<unknown, Error, { monthStart: Date; monthEnd: Date }>({
        mutationFn: refreshStatistics,
        onMutate: () => {
            const newKey = Math.random().toString(36).substring(2, 12)
            setnotificationKey(newKey)
            messagePending(newKey, "In Bearbeitung...", "Die Statistiken werden gerade aktualisiert.")
        },
        onSuccess: (data, variables) => {
            messageSuccess(notificationKey, "Fertig!", "Die Statistiken wurden erfolgreich aktualisiert.")
            queryClient.invalidateQueries({
                queryKey: [queryKey],
            })
        },
        onError: (err) => {
            messageError(notificationKey, "Fehler!", apiErrorMessage(err, "Die Statistiken konnten nicht aktualisiert werden."))
            console.log(err)
        },
    })

    return mutation
}

